import React, { useState, useEffect } from "react";
import top_section_logo from "../assets/images/top_section_logo.png";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import section_1 from "../assets/images/section-1.png";
import "./Section1.scss";

import SimpleModal from "./overlayComponents/SimpleModal";
import useCalculateHeightRatio from "../customHooks/useCalculateHeightRatio";
import Mint from "./Mint/Mint";

const Section1 = ({ JSONData }: any) => {
  const { image_file_size, content } = JSONData;
  const { sub_headers, currentValue, totalValue, logo } = content;

  const { heightRatio } = useCalculateHeightRatio({
    sectionImageHeight: image_file_size,
  });

  const [openModal, setOpenModal] = useState(false);

  const toggleModalHandler = () => {
    setOpenModal(!openModal);
  };

  return (
    <Box
      id="Merchandise"
      className="section-1-container"
      style={{ backgroundImage: `url(${section_1})`, ...heightRatio }}
    >
      <img
        src={top_section_logo}
        alt="section-logo"
        style={{ maxHeight: logo.size.height, maxWidth: logo.size.width }}
      />
      <Box className="group-info">
        <h1 className="main-header">NFTs To Save Endangered Animals</h1>
        <h1 className="sub-header">{sub_headers}</h1>
        <Mint />
      </Box>
      <SimpleModal
        modalMessage="Button Save the Flying Frogs is under construction"
        openModal={openModal}
        toggleModalHandler={toggleModalHandler}
      />
    </Box>
  );
};

export default Section1;
